// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import UserIcon from '../Icon/user';
import Select from '../Select';
import {encodeEmail} from 'lib/cloner-api/util';

import type {User} from 'lib/cloner-api';

type Props = {
	user: User,
	users: User[],
};

const UserValue = ({label}) =>
	<span>
		<UserIcon style={{fontSize: 'var(--lg-text)'}} />
		{' '}
		{label}
	</span>;

const UserOption = ({
	focusedOption,
	focusOption,
	key,
	labelKey,
	option,
	selectValue,
	style,
	valueArray,
}) => {
	const className = ['VirtualizedSelectOption'];

	if (option === focusedOption) {
		className.push('VirtualizedSelectFocusedOption');
	}

	if (option.disabled) {
		className.push('VirtualizedSelectDisabledOption');
	}

	if (valueArray && valueArray.indexOf(option) >= 0) {
		className.push('VirtualizedSelectSelectedOption');
	}

	const events = option.disabled
		? {}
		: {
				onClick: () => selectValue(option),
				onMouseOver: () => focusOption(option),
			};

	return (
		<div
			className={className.join(' ')}
			key={key}
			style={style}
			title={option.title}
			{...events}
		>
			<UserValue {...option} />
		</div>
	);
};

const defaultOptions = [];

type Option = {
	value: string,
	label: string,
};

class UserSelect extends PureComponent<Props> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	handleSelect = (option: Option) => {
		try {
			const userId = encodeEmail(option.value);
			this.context.router.replace(`/explorer?userId=${userId}`);
		} catch (error) {
			// ignore errors
		}
	};

	render() {
		const {user, users} = this.props;

		const loading = !user;

		let placeholder = 'Selecccione usuario';
		if (loading && !users) {
			placeholder = 'Cargando usuarios...';
		}

		const options = loading
			? defaultOptions
			: users.map(user => ({
					label: user.name,
					value: user.login,
				}));

		return (
			<Select
				clearable={false}
				optionRenderer={UserOption}
				valueRenderer={UserValue}
				placeholder={placeholder}
				options={options}
				value={loading ? null : user.login}
				onChange={this.handleSelect}
			/>
		);
	}
}

export default UserSelect;



// WEBPACK FOOTER //
// ./src/components/UserSelect/UserSelect.js